/**
 * Writing direction of a language.
 *
 * The application is left-to-right everywhere until a right-to-left language
 * (Hebrew today) is chosen, at which point `<html dir>` flips and the CSS
 * logical properties do the rest. A base subtag is enough — `he`, `he-IL` and
 * a future `ar-…` all answer the same way.
 */
export const RTL_LANGS = new Set(['he', 'ar', 'fa', 'ur']);

export function dirFor(lang: string): 'ltr' | 'rtl' {
  return RTL_LANGS.has((lang || '').split('-')[0]) ? 'rtl' : 'ltr';
}
